import { useHttpClient } from '@wix/fe-essentials/react';
import { useErrorHandler } from '@wix/fe-essentials-standalone/react';
import { createAppBuilderApplication as createAppBuilderApplicationHttp } from '@wix/ambassador-devcenter-devibe-server-v1-project/http';

interface CreateAppBuilderApplicationParams {
  templateId?: string;
  appName?: string;
}

export const useCreateAppBuilderApplication = () => {
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();

  const createAppBuilderApplication = async ({
    templateId,
    appName,
  }: CreateAppBuilderApplicationParams) => {
    const {
      data: { appId },
    } = await errorHandler.withErrorHandler(
      () =>
        httpClient.request(
          createAppBuilderApplicationHttp({
            templateId,
            appName,
          }),
        ),
      { errorCodesMap: {} },
    );

    if (!appId) {
      throw new Error('App was not created');
    }

    // Wait for app events to settle before opening App Builder.
    await new Promise((resolve) => setTimeout(resolve, 3000));

    return { appId };
  };

  return {
    createAppBuilderApplication,
    errorHandler,
  };
};
